import { render, staticRenderFns } from "./TerraIndigenaComSoja2425VegaParaguai.vue?vue&type=template&id=03fbb424&lang=pug"
import script from "./TerraIndigenaComSoja2425VegaParaguai.vue?vue&type=script&lang=js"
export * from "./TerraIndigenaComSoja2425VegaParaguai.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports